<template>
    <div class="container-fluid">
        <div class="event_place_box_bg">
            <h3>Events in</h3>
            <vue-google-autocomplete
                :name="city"
                id="map"
                class="form-control"
                placeholder="Start typing"
                v-on:placechanged="getAddressData"
                types="(cities)"
                style="display: none"
            >
            </vue-google-autocomplete
            ><span id="city_name" class="event_location">{{ defult_city }}</span
            ><span
                class="location_edit_btn"
                title="Edit Location"
                @click="showtext()"
                ><i class="las la-pen"></i
            ></span>
        </div>

        <div class="event_filter_list_bg">
            <ul>
                <li v-bind:class="{ active: activeCategory == null }">
                    <a @click="getEvents(null, latitude, longitude)">All</a>
                </li>
                <li
                    v-for="items in category"
                    :key="items.slug"
                    v-bind:class="{ active: items.slug == activeCategory }"
                >
                    <a @click="getEvents(items.slug, latitude, longitude)">{{
                        items.name
                    }}</a>
                </li>
            </ul>
        </div>

        <div v-if="results.length">
            <div class="event_card_box_bg">
                <evevnt-card
                    v-for="item in results"
                    :key="item.id"
                    :item="item"
                ></evevnt-card>
            </div>
        </div>
        <div v-else>
            <span class="text-center text-center ml-auto mr-auto"
                ><b> There are No Events ! </b></span
            >
        </div>
    </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
export default {
    name: "EventsIndex",
    data() {
        return {
            results: [],
            category: [],
            activeCategory: null,
            city: "",
            latitude: "",
            longitude: "",
            locations: [],
            slug: null,
            defult_city: localStorage.getItem("city"),
        };
    },
    created() {
        this.getEvents(this.slug, this.latitude, this.longitude);
    },
    components: {
        VueGoogleAutocomplete,
    },
    methods: {
        getEvents(slug, latitude, longitude, locations) {
            $(".preloader").show();
            if (
                this.latitude == localStorage.getItem("lat") ||
                this.latitude == ""
            ) {
                this.latitude = parseFloat(localStorage.getItem("lat"));
            }
            if (
                this.longitude == localStorage.getItem("lng") ||
                this.longitude == ""
            ) {
                this.longitude = parseFloat(localStorage.getItem("lng"));
            }
            if (
                this.locations == localStorage.getItem("city") ||
                this.locations == ""
            ) {
                this.locations = localStorage.getItem("city");
            }
            var url = "/api/events";
            this.activeCategory = slug;
            if (slug !== null) {
                this.activeCategory = slug;
            }
            axios
                .post(url, {
                    slug: slug,
                    let: this.latitude,
                    long: this.longitude,
                    locations: this.locations,
                })
                .then((response) => {
                    this.results = response.data.events;
                    this.category = response.data.event_category;
                    $(".preloader").hide();
                    console.log(this.results);
                })
                .catch((error) => {
                    $(".preloader").hide();
                    console.log(error);
                });
        },
        getAddressData: function (addressData, placeResultData) {
            this.latitude = addressData.latitude;
            this.longitude = addressData.longitude;
            this.locations = placeResultData.formatted_address;
            if (this.latitude == "") {
                this.latitude = localStorage.getItem("lat");
            }
            if (this.longitude == "") {
                this.longitude = localStorage.getItem("lng");
            }
            this.getEvents(
                this.slug,
                this.latitude,
                this.longitude,
                this.locations
            );

            $("#city_name").html(placeResultData.formatted_address);
            $("#map").hide();
        },
        showtext() {
            $("#map").show();
            $("#city_name").html("");
        },
    },
};
</script>
